import { useEffect, useState } from "react";
import { Layout, Menu, Image, Typography } from "antd";
import { useSelector } from "react-redux";
import get from "lodash/get";
import { useNavigate, useLocation } from "react-router-dom";
import { getAdminMenutems } from "../../utilities/layout";
import logo from "../../static/images/sochIOtLogo.jpeg";
import packageJson from "../../../package.json";

const { Sider } = Layout;
const { Text } = Typography;

const getLevelKeys = (items1) => {
  const key = {};
  const func = (items2, level = 1) => {
    items2.forEach((item) => {
      if (item.key) {
        key[item.key] = level;
      }
      if (item.children) {
        func(item.children, level + 1);
      }
    });
  };
  func(items1);
  return key;
};

const siderStyle = {
  overflow: "auto",
  height: "100vh",
  position: "sticky",
  insetInlineStart: 0,
  top: 0,
  bottom: 0,
  scrollbarWidth: "thin",
  scrollbarGutter: "stable",
  paddingRight: 0,
};

const LayoutSider = () => {
  const location = useLocation();
  const [selectKey, setSelectedKey] = useState("");
  const [collapsed, setCollapsed] = useState(true);
  const [isMobile, setIsMobile] = useState(false);
  const [stateOpenKeys, setStateOpenKeys] = useState([]);


  const authObj = useSelector((state) => get(state, "auth"))
  const isDevMode = process.env.REACT_APP_IS_DEV_MODE === "1";
  const permissions = useSelector((state) => get(state, "auth.permissions"));
  const navigate = useNavigate();
  const menuItems = getAdminMenutems(
    navigate,
    selectKey,
    authObj,
    permissions,
  );

  const levelKeys = getLevelKeys(menuItems);

  useEffect(() => {
    setSelectedKey(location.pathname);
  }, [location]);

  const onOpenChange = (openKeys) => {
    const currentOpenKey = openKeys.find(
      (key) => stateOpenKeys.indexOf(key) === -1,
    );
    // open
    if (currentOpenKey !== undefined) {
      const repeatIndex = openKeys
        .filter((key) => key !== currentOpenKey)
        .findIndex((key) => levelKeys[key] === levelKeys[currentOpenKey]);
      setStateOpenKeys(
        openKeys
          
          .filter((_, index) => index !== repeatIndex)
          
          .filter((key) => levelKeys[key] <= levelKeys[currentOpenKey]),
      );
    } else {
      // close
      setStateOpenKeys(openKeys);
    }
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <Sider
      style={siderStyle}
      theme="light"
      collapsible
      collapsed={collapsed}
      collapsedWidth={isMobile ? 0 : 100}
      trigger={null}
      defaultCollapsed
      onMouseEnter={() => setCollapsed(false)}
      onMouseLeave={() => setCollapsed(true)}
    >
      {/* Logo Section */}
      <div className="h-[73px] py-5 w-full flex justify-center items-center border-opacity-30">
        <Image src={logo} alt="logo" width={"90%"} preview={false} />
      </div>

      {/* Scrollable Menu Wrapper */}
      <div className="overflow-y-auto scrollbar-hidden sc mt-10  pb-[10%]">
        <Menu
          style={{ textAlign: "left", paddingRight: "0px" }}
          mode="inline"
          inlineIndent={10}
          openKeys={stateOpenKeys}
          onOpenChange={onOpenChange}
          className="bg-transparent space-y-5 "
          selectedKeys={[selectKey]}
          items={menuItems}
          onClick={(e) => navigate(e.key)}
        />
      </div>
      <div className="mt-auto mb-2 flex justify-center items-center">
        <Text className="text-xs" italic>
          V:{get(packageJson, "version")} ({isDevMode ? "S" : "P"})
        </Text>
      </div>
    </Sider>
  );
};

export default LayoutSider;
